'use es6';

import { Map as ImmutableMap } from 'immutable';
import formatProperty from 'reporting-data/hydrate/propertyFormatter';
import resolveOwnerReferences from 'reporting-data/references/owner';
import resolveTeamReferences from 'reporting-data/references/team';
const createReferences = dataset => dataset.update('properties', properties => properties.map((propertyInfo, propertyName) => {
  if (!propertyInfo.get('references')) {
    const references = dataset.get('data').map(point => point.get(propertyName)).toSet().reduce((collect, value) => collect.set(String(value), ImmutableMap({
      label: formatProperty(value, propertyInfo, propertyInfo.get('format', ImmutableMap()).toJS())
    })), ImmutableMap());
    return propertyInfo.set('references', references);
  }
  return propertyInfo;
}));
const updateProperties = (dataset, references, referencePropertyName) => {
  return dataset.update('properties', properties => properties.map((propertyInfo, propertyName) => {
    if (propertyName === referencePropertyName) {
      return propertyInfo.set('references', references);
    }
    return propertyInfo;
  }));
};
const generateReferences = dataset => {
  const ownerIds = dataset.get('data').map(point => point.get('hubspot_owner_id')).toSet().filter(value => value !== null && value !== undefined);
  const teamIds = dataset.get('data').map(point => point.get('hubspot_team_id')).toSet().filter(value => value !== null && value !== undefined);
  return Promise.all([resolveTeamReferences(teamIds), resolveOwnerReferences(ownerIds)]).then(([teamReferences, ownerReferences]) => {
    const newTeamReferences = teamReferences.mapKeys(String);
    const dataSetWithTeamProperties = updateProperties(dataset, newTeamReferences, 'hubspot_team_id');
    return updateProperties(dataSetWithTeamProperties, ownerReferences, 'hubspot_owner_id');
  }).then(createReferences);
};
export default (({
  report,
  response,
  datasets
}) => {
  const datasetNames = datasets.keySeq().toArray();
  return Promise.all(datasetNames.map(datasetName => generateReferences(datasets.get(datasetName)))).then(updatedDatasets => {
    return {
      report,
      response,
      datasets: updatedDatasets.reduce((collect, dataset, i) => collect.set(datasetNames[i], dataset), ImmutableMap())
    };
  });
});